import type { PresentationBlock } from 'paintscout'
import blockComponents from '../blocks'
import GeneralOptions from './GeneralOptions'

const noop = () => {
  /* no-op: only used to probe option counts, never actually invoked */
}

/**
 * Whether a block has anything to show in its Options popup (BlockMenu's Edit button +
 * BlockOptionsPopup), combining its own type-specific Options (if any) with the generic
 * background/format options every block normally gets. Kept in sync with the same
 * computation `BlockOptionsPopup`'s `Content` does, so the Edit button never opens an
 * empty popup (#21821 — surfaced by the Custom HTML/CSS block, which has neither).
 */
export function hasBlockOptions(args: { block: PresentationBlock; useCart: boolean }): boolean {
  const { block, useCart } = args

  const typeOptions = blockComponents[block.type]?.Options
    ? blockComponents[block.type].Options({ block, presetColors: [], handleOptionFieldChange: noop })
    : []

  const generalOptions = GeneralOptions({ block, palette: undefined, useCart, handleOptionFieldChange: noop })

  return typeOptions.length + generalOptions.length > 0
}
